// extracted by mini-css-extract-plugin
export default {"nextRacesWrapper":"styles_nextRacesWrapper__j9BfF","nextRacesWrapper__title":"styles_nextRacesWrapper__title__roPVc","nextRacesList":"styles_nextRacesList__Hv+r6"};